<section
  *ngIf="publishPlanProgressService.state().isVisible"
  class="publish-progress-toast"
  aria-live="polite"
  role="status"
>
  <div class="publish-progress-indicator"></div>
  <div class="publish-progress-content">
    <div class="publish-progress-title">Publish plan</div>
    <div class="publish-progress-message">{{ publishPlanProgressService.state().message }}</div>
  </div>
</section>